// utils/getStoredUser.js

export const getStoredUser = () => {
  try {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    return storedUser || null;
  } catch (error) {
    console.error("Invalid user data in localStorage", error);
    return null;
  }
};
